module.exports = __webpack_public_path__ + "img/VH.4bb483c5.svg";